// Copy overrides for the `vanguard_uh_custom_experience` flipper.
// Keys mirror the non-UH structure in `patientRxAuth.ts` so consumers can
// swap the root object (e.g. `l.UH.storeLandingPages.leftColumn` in place
// of `l.patientRxAuth.storeLandingPages.leftColumn`) without changing
// downstream keys. Keys that are UH-only additions (no non-UH counterpart)
// also live here.
export const UH = {
  storeLandingPages: {
    leftColumn: {
      tips: "{{storeName}} trusts Fullscript to power their store. Here's why you should too:",
      carousel: {
        slide4:
          "{{storeName}}’ supplement catalog is developed in collaboration with clinical experts at Connor Whole Health.",
      },
    },
  },
} as const;
